<template>
  <div class="bg">
    <div class="vux-1px-b">
      <x-input
        title="身份证"
        text-align="right"
        placeholder="请输入身份证"
        v-model="params.identityNo"
        placeholder-align="right"
        disabled="true"
      ></x-input>
    </div>
    <div class="vux-1px-b">
      <x-input
        title="银行卡"
        text-align="right"
        placeholder="请输入银行卡"
        v-model="params.bankCardNo"
        placeholder-align="right"
      ></x-input>
    </div>
    <div class="vux-1px-b" @click="$refs.bankList.show1 = true">
      <x-input
        title="开户银行"
        text-align="right"
        placeholder="请选择开户银行"
        v-model="params.bank"
        placeholder-align="right"
        @on-change="bankChange"
        disabled="true"
      ></x-input>
    </div>
    <bank-list ref="bankList" @getBankInfo="bankInfoChange"></bank-list>
    <div class="inputWrapper flex">
      <div class="inputTitle">开户地</div>
      <div class="inputBox flex1">
        <div style="width: 100%">
          <select
            id="province"
            ref="province"
            v-model="params.provinceCode"
            style="width: 30%"
            @change="changeProvince"
          >
            <option selected="selected" value=""></option>
            <option
              v-for="res in provinceList"
              :key="res.code"
              :value="res.code"
              >{{ res.name }}
            </option>
          </select>
          <select
            id="city"
            ref="city"
            style="width: 30%"
            v-model="params.cityCode"
            @change="changeCity"
          >
            <option selected="selected" value=""></option>
            <option v-for="res in cityList" :key="res.code" :value="res.code"
              >{{ res.name }}
            </option>
          </select>
          <select
            id="town"
            ref="town"
            style="width: 30%"
            v-model="params.areaCode"
            @change="changeArea"
          >
            <option selected="selected" value=""></option>
            <option v-for="res in areaList" :key="res.code" :value="res.code"
              >{{ res.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="vux-1px-b" @click="$refs.bankContactList.show1 = true">
      <x-input
        title="开户支行"
        text-align="right"
        placeholder="请选择支行"
        v-model="params.bankContactName"
        placeholder-align="right"
        disabled="true"
      ></x-input>
    </div>
    <bank-contact-list
      ref="bankContactList"
      @getContactBankInfo="contactBankInfoChange"
    ></bank-contact-list>
    <div class="vux-1px-b">
      <x-input
        title="手机号"
        text-align="right"
        placeholder="请输入银行预留手机号"
        v-model="params.mobile"
        placeholder-align="right"
      ></x-input>
    </div>
    <div class="vux-1px-b">
      <div class="flex">
        <x-input
          class="flex1"
          title="验证码"
          text-align="right"
          placeholder="请输入验证码"
          v-model="saveDate.validateCode"
          placeholder-align="right"
        ></x-input>
        <div class="code" :class="{ disabled: isDisable }" @click="getCode">
          {{ getMobileCodeText() }}
        </div>
      </div>
    </div>
    <div class="saveButton" v-if="loadingImg === true">
      <img class="loadingImg" src="../../assets/loading.gif" />
    </div>
    <div class="saveButton" @click="addBankCard" v-else>保存</div>

    <confirm
      v-model="show"
      title="操作提示"
      confirm-text="前去完善"
      @on-cancel="onCancel"
      @on-confirm="onConfirm"
    >
      <p style="text-align:center;">请先完善个人信息</p>
    </confirm>
  </div>
</template>

<script>
import {
  getProvinceCode,
  getCityCode,
  getAreaCode,
  getBindCode,
  bankBindActive
} from "../../api/bank";
import bankList from "./components/bankList";
import bankContactList from "./components/bankContactList";

export default {
  name: "addBankCard",
  components: { bankList, bankContactList },
  data() {
    return {
      show: false,
      loadingImg: false,
      wait_timer: false,
      isDisable: false,
      bankList: [],
      subbranchList: [],
      params: {
        identityNo: this.$store.state.user.userInfo.idCard,
        bankCardNo: "",
        bankContactName: "",
        bankContactNo: "",
        mobile: "",
        provinceCode: "",
        cityCode: "",
        areaCode: "",
        bank: ""
      },
      bankCode: "",
      provinceList: [],
      cityList: [],
      areaList: [],
      provinceId: "",
      cityId: "",
      saveDate: {
        bindBankId: "",
        bankId: "",
        validateCode: ""
      }
    };
  },
  created() {
    this.getProvinceList();
  },
  watch: {
    bankCode() {
      this.$refs.bankContactList.getContactsBankList({
        bankCode: this.bankCode,
        cityCode: this.params.cityCode,
        areaCode: this.params.areaCode
      });
    },
    "params.cityCode"() {
      this.$refs.bankContactList.getContactsBankList({
        bankCode: this.bankCode,
        cityCode: this.params.cityCode,
        areaCode: this.params.areaCode
      });
    },
    "params.areaCode"() {
      this.$refs.bankContactList.getContactsBankList({
        bankCode: this.bankCode,
        cityCode: this.params.cityCode,
        areaCode: this.params.areaCode
      });
    }
  },
  methods: {
    onConfirm() {
      this.$router.push("/user/myInfoChange");
    },
    bankInfoChange(val) {
      this.bankCode = val.code;
      this.params.bank = val.bank;
    },
    contactBankInfoChange(val) {
      this.params.bankContactName = val.bankContactName;
      this.params.bankContactNo = val.bankContactNo;
    },
    getProvinceList() {
      getProvinceCode()
        .then(res => {
          this.provinceList = res;
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    getCityList(e) {
      getCityCode(e)
        .then(res => {
          this.cityList = res;
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    getAreaList(e) {
      getAreaCode(e)
        .then(res => {
          this.areaList = res;
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    bankChange() {
      this.params.provinceCode = "";
      this.params.cityCode = "";
      this.params.areaCode = "";
      this.params.bankContactName = "";
      this.params.bankContactNo = "";
    },
    changeProvince() {
      this.params.cityCode = "";
      this.params.areaCode = "";
      this.params.bankContactName = "";
      this.params.bankContactNo = "";
      for (let i = 0; i < this.provinceList.length; i++) {
        if (this.provinceList[i].code === this.params.provinceCode) {
          this.provinceId = this.provinceList[i].id;
        }
      }
      this.getCityList({ provinceId: this.provinceId });
    },
    changeCity() {
      this.params.areaCode = "";
      this.params.bankContactName = "";
      this.params.bankContactNo = "";
      for (let i = 0; i < this.cityList.length; i++) {
        if (this.cityList[i].code === this.params.cityCode) {
          this.cityId = this.cityList[i].id;
        }
      }
      this.getAreaList({ provinceId: this.provinceId, cityId: this.cityId });
    },
    changeArea() {
      this.params.bankContactName = "";
      this.params.bankContactNo = "";
    },
    getCode() {
      let that = this;
      if (!this.params.identityNo) {
        this.$showMessage("身份证不能为空");
        this.show = true;
      } else if (!this.params.bankCardNo) {
        this.$showMessage("银行卡号不能为空");
      } else if (!this.params.mobile) {
        this.$showMessage("手机号不能为空");
      } else if (this.check.checkIdCard(this.params.identityNo) === false) {
        this.$showMessage("请输入正确身份证");
      }
      // else if (this.check.checkBankCard(this.params.bankCardNo) === false) {
      //   alert("请输入正确银行卡");
      // }
      else if (this.check.checkMobile(this.params.mobile) === false) {
        this.$showMessage("请输入正确手机号");
      } else {
        this.wait_timer = 59;
        this.isDisable = true;
        let timer_interval = setInterval(function() {
          if (that.wait_timer > 0) {
            that.wait_timer--;
          } else {
            that.isDisable = false;
            clearInterval(timer_interval);
          }
        }, 1000);
        getBindCode(this.params)
          .then(res => {
            this.saveDate.bindBankId = res.bindBankId;
          })
          .catch(err => {
            this.$showError(err);
            this.wait_timer = false;
            this.isDisable = false;
          });
      }
    },
    getMobileCodeText() {
      if (this.wait_timer > 0) {
        return this.wait_timer + "s后获取";
      }
      if (this.wait_timer === 0) {
        return "重新获取";
      }
      if (this.wait_timer === false) {
        return "获取验证码";
      }
    },
    addBankCard() {
      if (!this.saveDate.validateCode) {
        this.$showMessage("验证码不能为空");
      } else if (!this.saveDate.bindBankId) {
        this.$showMessage("参数错误，请重新获取验证码");
      } else {
        this.loadingImg = true;
        bankBindActive(this.saveDate)
          .then(() => {
            this.loadingImg = false;
            this.$showMessage("绑卡成功");
            this.$router.replace("/bankCard/bankCard");
          })
          .catch(err => {
            this.loadingImg = false;
            this.$showError(err);
          });
      }
    }
  }
};
</script>

<style scoped>
.disabled {
  pointer-events: none;
}

.flex {
  display: flex;
}

.flex1 {
  flex: 1;
}

.bg {
  background: #fff;
  overflow: hidden;
  font-size: 14px;
}

.code {
  width: 200px;
  height: 46px;
  line-height: 46px;
  background-color: #fff;
  border: 1px solid #039df8;
  color: #039df8;
  display: block;
  margin: 18px 20px;
  border-radius: 24px;
  float: right;
  font-size: 12px;
  text-align: center;
}

.saveButton {
  margin: 50px 30px;
  background: #039df8;
  height: 86px;
  line-height: 86px;
  text-align: center;
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
  letter-spacing: 10px;
}

.loadingImg {
  width: 32px;
  height: 32px;
  line-height: 86px;
}

.inputWrapper {
  background: #fff;
  text-align: left;
  overflow: hidden;
  padding: 36px 30px;
  border-bottom: 1px solid #e8e8e8;
}

.inputTitle {
  width: 120px;
  font-size: 14px;
  line-height: 42px;
}

.inputBox {
  font-size: 14px;
  line-height: 42px;
  color: #262626;
}

.inputBox input {
  height: 40px;
  line-height: 42px;
  width: 100%;
  text-align: right;
}
</style>
